import { useEffect } from 'react';

import ErrorStatusPage from 'components/ErrorStatus';
import Page from 'components/Page';
import Layout from 'components/layouts/Layout';

import report from 'lib/report';

type Server500ErrorProps = {
  error: Error | null;
};

export default function Server500Error(props: Server500ErrorProps) {
  const { error } = props;

  useEffect(() => {
    report(error || new Error('Unhandled 500'), {
      tags: {
        surface: '500',
      },
    });
  }, []);

  return (
    <Layout backgroundColor="$black100">
      <Page absolute headerMode="DARK" title="Something went wrong" noFooter>
        <ErrorStatusPage code={500} error={props.error || null} />
      </Page>
    </Layout>
  );
}

Server500Error.defaultProps = {
  context: null,
};
